import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Field, reduxForm } from 'redux-form';
import {
	FormGroup,
	InputGroup,
	Button,
	ButtonToolbar,
	ControlLabel,
	FormControl,
	HelpBlock,
	Modal,
	Tabs,
	Tab
} from 'react-bootstrap';
import { required, validPercentage } from '../../../forms';
import BookingPlaceSearch from './BookingPlaceSearch';
import Select from 'react-select';
import DefineRate from './DefineRateModal';
import TabbedInput from './TabbedInput';


export const renderBootstrapField = ({ input, label, type, placeholder, id, value, meta: { touched, error, warning } }) => (
	<InputGroup>
		{label && <ControlLabel>{label}</ControlLabel>}
		<FormControl
			{...input}
			type={type}
			label={label}
			placeholder={placeholder}
			id={id}
			value={value}
		/>
		{touched &&
			((error && <span>{error}</span>) ||
				(warning && <span>{warning}</span>))}
	</InputGroup>
);

const formatMoney = (value, currency) => {
	if (!value) return value;
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		minimumFractionDigits: 2,
		currency,
	});
	return formatter.format(value);
};

const Currency = [
	{
		label: '🇦🇺 AUD - Australian Dollar',
		value: 'AUD',
	},
	{
		label: '🇨🇦 CAD - Canadian Dollar',
		value: 'CAD',
	},
	{
		label: '🇨🇳 CNY - Chinese Yuan Renminbi',
		value: 'CNY',
	},
	{
		label: '🇪🇺 EUR - Euro',
		value: 'EUR',
	},
	{
		label: '🇬🇧 GBP - British Pound',
		value: 'GBP',
	},
	{
		label: '🇯🇵 JPY - Japanese Yen',
		value: 'JPY',
	},
	{
		label: '🇲🇽 MXN - Mexican Peso',
		value: 'MXN',
	},
	{
		label: '🇺🇸 USD - US Dollar',
		value: 'USD',
	},
	{
		label: '🇨🇭 CHF - Swiss Franc',
		value: 'CHF',
	},
	{
		label: '🇳🇿 ZND - New Zealand Dollar',
		value: 'ZND',
	},
	{
		label: '🇦🇷 ARS - Argentinian peso',
		value: 'ARS',
	},
	{
		label: '🇨🇱 CLP - Chilean Peso',
		value: 'CLP',
	},
	{
		label: '🇩🇰 DKK - Danish Krone',
		value: 'DKK',
	},
	{
		label: '🇮🇳 INR - Indian Rupee',
		value: 'INR',
	},
	{
		label: '🇰🇷 KRW - Korean Won',
		value: 'KRW',
	},
	{
		label: '🇳🇴 NOK - Norwegian Krone',
		value: 'NOK',
	},
	{
		label: '🇷🇺 RUB - Russian Ruble',
		value: 'RUB',
	},
	{
		label: '🇦🇪 AED - UAE Dirham',
		value: 'AED',
	},
	{
		label: '🇿🇦 ZAR - South African Rand',
		value: 'ZAR',
	},
	{
		label: '🇧🇷 BRL - Brazilian Real',
		value: 'BRL',
	},
	{
		label: '🇮🇸 ISK - Icelandic Krona',
		value: 'ISK',
	},
	{
		label: '🇮🇱 ILS - Israel new Shekel',
		value: 'ILS',
	},
	{
		label: '🇵🇱 PLN - Polish Zloty',
		value: 'PLN',
	},
	{
		label: '🇶🇦 QAR - Qatari Riyal',
		value: 'QAR',
	},
	{
		label: '🇹🇷 TRY - Turkish Lira',
		value: 'TRY',
	},
	{
		label: '🇸🇪 SEK - Swedish krona',
		value: 'SEK',
	},
];
const hStyle = { color: 'red' };
const getBorderStyle = (touched, errorMsg) => {
	const style = {
		border: '1px solid #ccc',
		borderBottom: 'none',
		textAlign: 'right',
		paddingRight: '10px',
	};
	if (touched && errorMsg) {
		style.border = '1px solid #a94442';
		style.borderBottom = '1px solid #a94442';
	}
	return style;
};

const NoteInput = ({ input, label, type, help, meta }) => (
	<FormGroup>
		<ControlLabel>Note</ControlLabel>
		<FormControl
			{...input}
			componentClass="textarea"
			name="note"
			placeholder="Add a note about this booking."
		/>
		{help && <HelpBlock>{help}</HelpBlock>}
	</FormGroup>
);

const TotalInput = ({ input, label, type, help, meta }) => (
	<FormGroup>
		<ControlLabel>Total</ControlLabel>
		<FormControl
			{...input}
			componentClass="textarea"
			name="total"
			placeholder="Enter rates for this value to be calculated."
		/>
		{help && <HelpBlock>{help}</HelpBlock>}
	</FormGroup>
);
const SelectInput = ({
	input,
	options,
	name,
	id,
	label
}) => (
	<FormGroup>
		<ControlLabel>{label}</ControlLabel>
		<Select
			id={id}
			name={name}
			options={options}
			value={input.value}
			onChange={(value) => {
				input.onChange(value.value);
			}}
			onBlur={value => input.onBlur(value.value)}
		/>
	</FormGroup>
);

const RenderSelectInput = ({ input, options, name, id, label }) => (
	<FormGroup>
		<ControlLabel>{label}</ControlLabel>
		<Select
			id={id}
			name={name}
			options={options}
			value={input.value}
			onChange={(value) => {
				input.onChange(value);
			}}
			onBlur={value => input.onBlur(value.value)}
		/>
	</FormGroup>
);

export const ReadOnlyInput = ({ input, label, placeholder, help, type, value, meta }) => (
	<InputGroup>
		<ControlLabel>{label}</ControlLabel>
		<FormControl {...input} type={type} placeholder={placeholder} value={value} readOnly />
		{help && <HelpBlock>{help}</HelpBlock>}
		{ /*meta.touched &&
			((meta.error && (
				<div>
					<span className="danger">{meta.error}</span>
				</div>
			)) ||
				(meta.warning && (
					<div>
						<span className="danger">{meta.warning}</span>
					</div>
				)))*/}
	</InputGroup>
);


const BookingForm = (props) => {
	const selectRoomTypeOptions = ['Suite', 'King', 'Double', 'Two Beds', 'Junior Suite', '2 Bedroom Suite'];
	const { handlechangevalue,updatedRowVlaue, handleSubmit, groups, onRateChange, handleCancel, cellEditProp, bid_details_input, eventList, tour, pristine, isNew, reset, submitting, onGroupChange, onEventChange, handlePlaceSelect, hotelAddress, address, placeTextBoxChange, changeCheckBox, checkboxFormatter, checkboxkingFormatter, checkboxdoubleFormatter, showDefineRateModal, closeDefineRateModal, showDefineRateModalFlag, calculateAndUpdateTotalValue, currency_initial_value, handleChange, handleShowSetRoomTypes, isGroupSelected, showSetRoomTypes, handleCloseSetRoomTypes, selectedGroup, handleUpdateRoomTypes, checkboxsuiteFormatterRoomType, checkboxkingFormatterRoomType, checkboxdoubleFormatterRoomType, handleLocationChange, handleShowHotelsList, changeCheckBoxValue, changeStateValue } = props;

	const handleCellEdit = (row, fieldName, value) => {
		
		handlechangevalue(row,fieldName,value)
	}

	return (
		<div>
			<form onSubmit={handleSubmit}>
				<FormGroup>
					<Field
						label="Select Hotel"
						placeholder="Search by Hotel Name"
						component={renderBootstrapField}
						id="selectHotelField"
						value={props.place}
						onChange={handleLocationChange}
						place={props.place}
						validate={[required]}
						name="selected_hotel"
					/>
					<Button
						bsStyle="success"
						onClick={handleShowHotelsList}
					>
						<i className="fa fa-search fa-lg" />
						Search
					</Button>
				</FormGroup>
				{/* <FormGroup>
					<Field
						name="event"
						type="input"
						component={RenderSelectInput}
						label="Event"
						options={eventList}
						onChange={onEventChange}
					/>
				</FormGroup>
				<FormGroup>
					<Field
						name="group"
						type="text"
						component={RenderSelectInput}
						label="Group"
						options={groups}
						onChange={onGroupChange}
					/>
				</FormGroup> */}
				<FormGroup>
					<Field
						name="event"
						type="input"
						component={TabbedInput}
						label="Event"
						options={eventList}
						onSelect={onEventChange}
					/>
				</FormGroup>
				<FormGroup>
					<Field
						name="group"
						type="text"
						component={TabbedInput}
						label="Group"
						options={groups}
						onSelect={onGroupChange}
					/>
				</FormGroup>
				<FormGroup>
					Currency
					<Select
						id="currency"
						name="currency"
						type="text"
						component={SelectInput}
						label="Currency"
						options={Currency}
						value={currency_initial_value}
						onChange={handleChange}
						defaultValue={{
							label: '🇺🇸 USD - US Dollar',
							value: 'USD',
						}}
					/>
				</FormGroup>
				<div className="row">
					<div className="col-md-6">
						<FormGroup>
							<InputGroup
								style={{
									display: 'table',
									width: '100%',
								}}
							>
								<InputGroup.Addon>Tax Rate</InputGroup.Addon>
								<FormControl required type="number" min="0.00" max="99.99" step="0.01" value={bid_details_input.tax_rate} onChange={(e) => onRateChange(e, "tax_rate")} style={getBorderStyle(false, false)} />
								<InputGroup.Addon>%</InputGroup.Addon>
							</InputGroup>
							<FormControl.Feedback />
						</FormGroup>
					</div>
					<div className="col-md-6">
						<ButtonToolbar>
							{/* <Button
								bsStyle="info"
								id="defineRate"
								onClick={showDefineRateModal}
							>
								Define Rate
							</Button> */}
							{/* {isGroupSelected && (<Button
								bsStyle="info"
								id="setRoomTypes"
								onClick={handleShowSetRoomTypes}
							>
								Set Room Types
							</Button>)} */}
						</ButtonToolbar>
					</div>
				</div>
				<FormGroup>
					<div className="row">
						<BootstrapTable
							data={bid_details_input.bidData}
							striped
							cellEdit={{
								mode: 'click',
								blurToSave: true,
								afterSaveCell: handleCellEdit
							}}
						// cellEdit={cellEditProp}
						>
							<TableHeaderColumn dataField="id" width="100" hidden isKey>ID</TableHeaderColumn>
							<TableHeaderColumn dataField="roomType" width="150" headerAlign="center" dataAlign="center"
								editable={{
									type: 'select',
									options: { values: selectRoomTypeOptions },
									validator: (value) => value !== ''
								}}
							>
								Room Type
							</TableHeaderColumn>
							<TableHeaderColumn dataField="numberOfRooms" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}> No of rooms</TableHeaderColumn>
							<TableHeaderColumn dataField="date_in" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date in &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
							<TableHeaderColumn dataField="date_out" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Date out &nbsp; <i className="fa fa-calendar-o" aria-hidden="true" /> </TableHeaderColumn>
							<TableHeaderColumn dataField="rate_per_night" dataFormat={(cell) => formatMoney(cell, currency_initial_value.value)} onChange={(e) => onRateChange(e, "rate_per_night")} width="100" headerAlign="center" dataAlign="center" editable={{ type: 'number' }}>Rate Per Night</TableHeaderColumn>
							{/* <TableHeaderColumn dataField="id" width="100" hidden isKey>ID</TableHeaderColumn>
							<TableHeaderColumn dataField="first_name" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >First Name</TableHeaderColumn>
							<TableHeaderColumn dataField="last_name" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}>Last Name</TableHeaderColumn>
							<TableHeaderColumn dataField="check_in_date" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Check-In Date</TableHeaderColumn>
							<TableHeaderColumn dataField="check_out_date" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Check-Out Date</TableHeaderColumn>
							<TableHeaderColumn dataField="rate_per_night" dataFormat={(cell) => formatMoney(cell, currency_initial_value.value)} onChange={(e) => onRateChange(e, "rate_per_night")} width="100" headerAlign="center" dataAlign="center" editable={{ type: 'number' }}>Rate Per Night</TableHeaderColumn>
							<TableHeaderColumn dataField="Suite" width="70" headerAlign="center" dataAlign="center" dataFormat={checkboxFormatter} editable={false}>Suite</TableHeaderColumn>
							<TableHeaderColumn dataField="King" width="70" headerAlign="center" dataAlign="center" dataFormat={checkboxkingFormatter} editable={false}>King</TableHeaderColumn>
							<TableHeaderColumn dataField="Double" width="70" headerAlign="center" dataAlign="center" dataFormat={checkboxdoubleFormatter} editable={false}>Double</TableHeaderColumn>
							<TableHeaderColumn dataField="group_id" width="10" headerAlign="center" dataAlign="center" hidden>Group Id</TableHeaderColumn>
							<TableHeaderColumn dataField="user_id" width="10" headerAlign="center" dataAlign="center" hidden>USer Id</TableHeaderColumn>
							<TableHeaderColumn dataField="bid_detail_id" width="10" headerAlign="center" dataAlign="center" hidden>Bid Detail Id</TableHeaderColumn>
							<TableHeaderColumn dataField="bid_id" width="10" headerAlign="center" dataAlign="center" hidden>Bid Id</TableHeaderColumn> */}
						</BootstrapTable>
					</div>
				</FormGroup>
				<div className="row">
					<div className="col-md-6">
						<FormGroup>
							<InputGroup
								style={{
									display: 'table',
									width: '100%',
									marginTop: '15px'
								}}
							>
								<InputGroup.Addon>Commision</InputGroup.Addon>
								<FormControl type="number" step="0.00" min="0.00" max="99.99" value={bid_details_input.commission_rate} onChange={(e) => onRateChange(e, "commission_rate")} style={getBorderStyle(false, false)} />
								<InputGroup.Addon>%</InputGroup.Addon>
							</InputGroup>
							<FormControl.Feedback />
						</FormGroup>
					</div>
					<div className="col-md-3 bid-detail-form-additional-tax">
						<FormGroup>
							<ControlLabel>Additional Tax (per day)</ControlLabel>
							<FormControl
								placeholder="Additional Tax"
								type="number"
								step="0.00"
								min="0.00"
								max="99.99"
								value={bid_details_input.additional_tax}
								onChange={(e) => onRateChange(e, "additional_tax")}
							/>
						</FormGroup>
					</div>
					<div className="col-md-3 bid-detail-form-additional-tax">
						<FormGroup>
							<ControlLabel>Resort Fee (per day)</ControlLabel>
							<FormControl
								placeholder="Resort Fee"
								type="number"
								step="0.00"
								min="0.00"
								max="99.99"
								value={bid_details_input.resort_fee}
								onChange={(e) => onRateChange(e, "resort_fee")}
							/>
						</FormGroup>
					</div>
				</div>
				<FormGroup>
					<ReadOnlyInput
						name="total"
						type="text"
						readOnly
						placeholder="Enter rates for this value to be calculated."
						label="Total"
						help="Estimated total including tax"
						value={bid_details_input.total}
					/>

				</FormGroup>
				<FormGroup>
					<Field
						name="note"
						type="textarea"
						component={NoteInput}
						label="Note"
						help="Please enter pricing and commission in appropriate boxes. Do not put commission in notes area. Use this area to clarify offering or to ask questions."
					/>
				</FormGroup>
				<div style={hStyle}>
					<p>Please note this is for a Hotel booking made outside Catch, once saved the booking will be added as a Hotel Option for Clients.</p>
				</div>
				<FormGroup>
					<ButtonToolbar>
						<Button
							// disabled={submitting}
							bsStyle="success"
							type="submit"
							id="btnAddBookingSubmit"
						>
							Submit
						</Button>
						<Button
							disabled={submitting}
							bsStyle="info"
							type="reset"
							onClick={handleCancel}
						>
							Cancel
						</Button>
					</ButtonToolbar>
				</FormGroup>
			</form>
			<DefineRate
				showDefineRateModalFlag={showDefineRateModalFlag}
				showDefineRateModal={showDefineRateModal}
				closeDefineRateModal={closeDefineRateModal}
				bid_details_input={bid_details_input}
				calculateAndUpdateTotalValue={calculateAndUpdateTotalValue}
				changeCheckBoxValue={changeCheckBoxValue}
				changeStateValue={changeStateValue}
				updatedRowVlaue={updatedRowVlaue}
			/>

			{showSetRoomTypes && (<Modal show={showSetRoomTypes} onHide={handleCloseSetRoomTypes} backdrop="static">
				<Modal.Header closeButton>
					<Modal.Title>Set Room Types</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div id="setRoomTypeModalSection">
						<BootstrapTable
							data={selectedGroup}
							striped
						>
							<TableHeaderColumn dataField="group" width="80" headerAlign="center" dataAlign="center" editable={false} >Group</TableHeaderColumn>
							<TableHeaderColumn dataField="Suite" width="50" headerAlign="center" dataAlign="center" dataFormat={checkboxsuiteFormatterRoomType} editable={false}>Suite</TableHeaderColumn>
							<TableHeaderColumn dataField="King" width="50" headerAlign="center" dataAlign="center" dataFormat={checkboxkingFormatterRoomType} editable={false}>King</TableHeaderColumn>
							<TableHeaderColumn dataField="Double" width="50" headerAlign="center" dataAlign="center" dataFormat={checkboxdoubleFormatterRoomType} editable={false}>Double</TableHeaderColumn>
							<TableHeaderColumn dataField="group_id" isKey width="1" headerAlign="center" dataAlign="center" hidden>Group ID</TableHeaderColumn>
						</BootstrapTable>
					</div>
					<ButtonToolbar className="margin-top-5" style={{ float: 'right' }}>
						<Button
							bsStyle="success"
							onClick={handleUpdateRoomTypes}
						>
							Apply
						</Button>
					</ButtonToolbar>
				</Modal.Body>
				<Modal.Footer style={{ clear: 'both' }} />
			</Modal>
			)}
		</div>
	);
};
export default reduxForm({
	form: 'BookingForm', // a unique identifier for this form
})(BookingForm);


// WEBPACK FOOTER //
// src/routes/tours/components/BookingForm.js